import React, { useMemo,  useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

import { getUsuarioStorage } from '../helpers/getUsuarioStorage';

import LoadingOverlay from './LoadingOverlay'
import { serverApi } from '../api';
import { Stack } from 'react-bootstrap';

const initialForm = {
    anteriorPassword: "",
    nuevoPassword: "",
    repitePassword: "",
};



export const UsuarioPassword = ( {show, onClose} ) => {
    
    const usuario = useMemo(() => getUsuarioStorage(), []);

    const [form, setForm] = useState(initialForm);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    
    const validarFormulario = () => {

        const {
            anteriorPassword,
            nuevoPassword,
            repitePassword,
        } = form;

        if (
            !anteriorPassword.trim() ||
            !nuevoPassword.trim() ||
            !repitePassword.trim()
        ) {
            return "Todos los campos son obligatorios";
        }

        if (anteriorPassword === nuevoPassword) {
            return "La nueva contraseña debe ser diferente";
        }

        if (nuevoPassword !== repitePassword) {
            return "Las contraseñas no coinciden";
        }

        if (nuevoPassword.length < 6) {
            return "La contraseña debe tener mínimo 6 caracteres";
        }

        return null;
    };

    const handleChange = ({ target }) => {
        const { name, value } = target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (error) setError("");
    };

    const limpiarFormulario = () => {
        setForm(initialForm);
        setError("");
    };

    const handleClose = () => {
        limpiarFormulario();
        onClose();
    };

    const handleSubmit = async(ev) => {
       
        ev.preventDefault();
      
        const errorValidacion = validarFormulario();

        if (errorValidacion) {
            return setError(errorValidacion);
        }

    
        const codigoEntidad = usuario.codigoEntidad;
        const uidUsuario = usuario.uidUsuario;
        try {
            setIsLoading(true);

            const res = await serverApi.post(
                `/usuarios/cambia-password`,
                {
                    ...form,
                    codigoEntidad,
                    uidUsuario,
                }
            );

            console.log(res);
            
            if (res.data.ok === true) {
                handleClose();
                return;
            }

            setError(res.data.resp || "No fue posible cambiar la contraseña");

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }


        // setIsLoading(true);
        // socket.emit( 'cambia-Password', datos, ( res ) => {
        //     console.log( res )
        //     setIsLoading(false);
        //     if( res[0] === "" ){
        //         setShowAlert(true)
        //         setContenidoError( res[1] );
        //     }else
        //     if( res[0] === 1 ){
        //         props.onHide(false)
        //         console.log (props.onHide);
        //         setShowAlert(false);
        //     }else{
        //         console.log( res );
        //     }


        // })



    }
  
    return (
      <>
        {isLoading && <LoadingOverlay />}

        <Modal 
            show={show}
            onHide={handleClose}
            centered
            backdrop="static"
            className={`content ${isLoading ? 'opacity' : ''} m-5`}
        >
          <Modal.Header closeButton>
            <Modal.Title>Cambiar contraseña</Modal.Title>
          </Modal.Header>

            
            <Form onSubmit={ handleSubmit }>
                <Modal.Body>

                    {!!error && (
                        <Alert
                            variant="danger"
                            dismissible
                            onClose={() => setError("")}
                        >
                            {error}
                        </Alert>
                    )}

                    <Form.Group className="mb-3" controlId="anteriorPassword">
                        <Form.Label>Contraseña actual</Form.Label>
                        <Form.Control
                            type="password"
                            name="anteriorPassword"
                            value={form.anteriorPassword}
                            onChange={handleChange}
                            autoComplete="current-password"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="nuevoPassword">
                        <Form.Label>Nueva contraseña</Form.Label>
                        <Form.Control
                            type="password"
                            name="nuevoPassword"
                            value={form.nuevoPassword}
                            onChange={handleChange}
                            autoComplete="new-password"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="repitePassword">
                        <Form.Label>Confirmar contraseña</Form.Label>
                        <Form.Control
                            type="password"
                            name="repitePassword"
                            value={form.repitePassword}
                            onChange={handleChange}
                            autoComplete="new-password"
                        />
                    </Form.Group>
                </Modal.Body>
              
                <Modal.Footer>

                    <Stack
                        direction="horizontal"
                        gap={2}
                        className="ms-auto"
                    >
                        <Button
                            variant="secondary"
                            onClick={handleClose}
                            disabled={isLoading}
                        >
                            Cancelar
                        </Button>

                        <Button
                            type="submit"
                            variant="success"
                            disabled={isLoading}
                        >
                            Guardar
                        </Button>
                    </Stack>

                </Modal.Footer>
            </Form>
        </Modal>
      </>
  )
}
